import { SalesOrderStatus } from '../constants/sales-order-status.js';
/** The stages a Move Back can land on, ACCEPTED only for runs that wrote Accepted. */
export const SALES_ORDER_REVERT_TARGETS = [
    'AWAITING_APPROVAL',
    'SUBMITTED',
    'ACCEPTED',
    'DELIVERY_SCHEDULING',
];
/** 'auto' when the pick started on the auto path (Ready to Deliver is written by the workflow), 'manual' for runs that wrote Accepted. */
export const SALES_ORDER_READY_TO_DELIVER_MODES = ['auto', 'manual'];
/** The one stage a Standard order moves back to, or null when it can't move back. */
export function salesOrderRevertTarget({ statusId, path, readyToDeliverMode, hasApprovalTriggers, }) {
    if (path !== 'Standard')
        return null;
    switch (statusId) {
        case SalesOrderStatus.SUBMITTED:
            return hasApprovalTriggers ? 'AWAITING_APPROVAL' : null;
        case SalesOrderStatus.ACCEPTED:
            return readyToDeliverMode === 'manual' ? 'SUBMITTED' : null;
        case SalesOrderStatus.DELIVERY_SCHEDULING:
            if (readyToDeliverMode === 'auto')
                return 'SUBMITTED';
            return readyToDeliverMode === 'manual' ? 'ACCEPTED' : null;
        case SalesOrderStatus.READY_TO_DELIVER:
            return readyToDeliverMode ? 'DELIVERY_SCHEDULING' : null;
        default:
            return null;
    }
}
//# sourceMappingURL=sales-order-revert-target.js.map